import { extendObservable, runInAction } from 'mobx';

import { ProductsController } from '../../../networking/controllers/ProductsController';
import { Logger } from '../../../helpers/Logger';

class CategoryProductsStoreClass {
  constructor() {
    extendObservable(this, {
      products: null,
      group: null,
      error: null,
    });
  }

  async fetchProductsForGroup(slug) {
    try {
      const { group, products } = await ProductsController.findByGroupNewApi(slug);
      runInAction(() => {
        this.products = products;
        this.group = group;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.error = error;
      });
    }
  }
}

export const CategoryProductsStore = new CategoryProductsStoreClass();



// WEBPACK FOOTER //
// ./src/pages/product-group/stores/CategoryProductsStore.js